export const ROOT = '/';
export const HOME = '/home';
export const POST_DETAIL = '/user/:user/post/:post';
